import { render, staticRenderFns } from "./giftActivityDetail.vue?vue&type=template&id=43af9a0e&scoped=true"
import script from "./giftActivityDetail.vue?vue&type=script&lang=js"
export * from "./giftActivityDetail.vue?vue&type=script&lang=js"
import style0 from "./giftActivityDetail.vue?vue&type=style&index=0&id=43af9a0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43af9a0e",
  null
  
)

export default component.exports